import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["color", "fontSize", "className", "style"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof _Symbol && _getIteratorMethod(r) || r["@@iterator"]; if (!t) { if (_Array$isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { var _context; if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = _sliceInstanceProperty(_context = {}.toString.call(r)).call(_context, 8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from "react";
import { Icon as MuiIcon } from "@mui/material";
import { ICON_SVG_FALLBACKS } from "./iconSvgFallbacks";
import { jsx as _jsx } from "react/jsx-runtime";
var FONT_SIZE_MAP = {
  xsmall: 14,
  small: 16,
  medium: 20,
  "default": 24,
  large: 28,
  xlarge: 40
};

// Some icons are served only from the third-party Font Awesome CDN, which a few
// client networks block (RKG-7640). For a curated set we render the glyph as
// inline SVG instead, so it never depends on the CDN. Any icon not in the map
// falls through to the normal Font Awesome font rendering below.
var findSvgFallback = function findSvgFallback(className) {
  if (!className) {
    return undefined;
  }
  var _iterator = _createForOfIteratorHelper(className.split(/\s+/)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var token = _step.value;
      var name = token.replace(/^fa-/, "");
      if (Object.prototype.hasOwnProperty.call(ICON_SVG_FALLBACKS, name)) {
        return ICON_SVG_FALLBACKS[name];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return undefined;
};

/** Overrides the Material UI Icon Component so we can add custom RaiseColors and font sizes */
var Icon = function Icon(_ref) {
  var color = _ref.color,
    fontSize = _ref.fontSize,
    className = _ref.className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    muiIconProps = _objectWithoutProperties(_ref, _excluded);
  if (typeof fontSize === "string" && fontSize in FONT_SIZE_MAP) {
    fontSize = FONT_SIZE_MAP[fontSize];
  }
  var svgFallback = findSvgFallback(className);
  if (svgFallback) {
    // Size the svg like a font glyph: width/height in `em` driven by the svg's
    // own font-size, so a numeric fontSize, "inherit", or the default all behave
    // the way the Font Awesome font icon did (a raw `width="inherit"` is invalid
    // and balloons the svg). Default 24 matches MUI's "medium".
    return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, muiIconProps), {}, {
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: svgFallback.viewBox,
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": true,
      style: _objectSpread({
        fontSize: fontSize !== null && fontSize !== void 0 ? fontSize : 24,
        color: color,
        verticalAlign: "-0.125em"
      }, style),
      children: /*#__PURE__*/_jsx("path", {
        d: svgFallback.path
      })
    }));
  }
  return /*#__PURE__*/_jsx(MuiIcon, _objectSpread({
    className: className,
    style: _objectSpread({
      color: color,
      fontSize: fontSize,
      width: "initial",
      height: "initial"
    }, style)
  }, muiIconProps));
};
export default Icon;